import "babel-polyfill";
import { binder, fwa } from "./libs/binder";
import { staticFunctions, constants, commonFunction, anotherCommonFunction, navFunction, myUnusedFunction } from "./modules/module";
import "./libs/jcf.js";
import "./libs/jcf-select.js";
import "./libs/slick";
import { Menu } from "./modules/Menu";
import { StepsForms } from "./modules/StepsForms";
import { HeplSlider } from "./modules/HelpSlider";
import { TestimonialsSlider } from "./modules/TestimonialsSlider";
import { accordion } from "./modules/accordion";
import { customSelect } from "./modules/custom-select";
import { popups } from "./modules/popups";
import { TeamSlider } from "./modules/TeamSlider";
import { animationOnScroll } from "./modules/animationOnScroll";
import { Tickers } from "./modules/Tickers";
import Corner from "./modules/Сorner";
import { ContactsHover } from "./modules/ContactsHover";
import { loader } from "./modules/loader";

binder({
    bounds: {
        "html": [constants, staticFunctions],
        "body": [commonFunction, anotherCommonFunction],
        ".header": Menu,
        "select": customSelect,
        ".popup-link": popups,
        ".case-evaluation-form": StepsForms,
        ".help-slider": HeplSlider,
        ".testimonials-slider": TestimonialsSlider,
        ".team-slider": TeamSlider,
        ".accordion": accordion,
        ".has-animation": animationOnScroll,
        ".has-count-animation": animationOnScroll,
        ".marquee": Tickers,
        ".corner": Corner,
        ".contacts-section": ContactsHover,
        ".loader": loader,


    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js